import { useAuthorCommissioningStore } from '@/stores/useAuthorCommissioningStore'

export function ProposalCard({
  onAccept,
  disabled,
}: {
  onAccept: () => void
  disabled: boolean
}) {
  const proposalText = useAuthorCommissioningStore((s) => s.proposalText)
  const phase = useAuthorCommissioningStore((s) => s.phase)

  if (!proposalText) return null
  // After contract acceptance the chat takes over; hide the card.
  if (phase === 'contracted') return null

  return (
    <div className="author-proposal">
      {proposalText}
      <div className="author-proposal__actions">
        <button
          type="button"
          className="author-proposal__button"
          onClick={onAccept}
          disabled={disabled}
        >
          accept
        </button>
        <span>·</span>
        <button
          type="button"
          className="author-proposal__button"
          disabled
          title="pushback handling lands in M5"
        >
          something's off
        </button>
      </div>
    </div>
  )
}
